// :popover-open throws in selector engines that don't know it (jsdom)
export function isPopoverShown(element: HTMLElement): boolean {
  try {
    return element.matches(':popover-open');
  } catch {
    return false;
  }
}
